<script>
export default {
	methods: {
		getLinkTarget(link) {
			return link && (link.includes('https://') || link.includes('http://') || link.includes('//')) ? '_blank' : '_self';
		}
	},
};
</script>